import { useEffect } from 'react'

import { IconCube, IconCubeSolid } from '@swaggerhub-portal/component-library'
import { clsx } from 'clsx'
import { Link, useLocation, useOutletContext } from 'react-router'

import { useScrollIntoView } from '~/hooks/useScrollIntoView'
import { API_TYPE, Schema } from '~/types/content'
import { RootOutletContext } from '~/types/portal'

export const ApiSubNavSchema = ({
  parentPath,
  schema,
  active = false,
  isSelected,
  setSelectedSchema,
  onClick,
  apiType
}: {
  parentPath: string,
  schema: Schema,
  active?: boolean,
  isSelected: boolean,
  setSelectedSchema: (selectedSchema: string | null) => void,
  onClick?: (e) => void,
  apiType?: API_TYPE
}) => {
  const { hash: locationHash } = useLocation()
  const schemaIdentifier = apiType === API_TYPE.ASYNCAPI ? (schema.name || schema?.title) || '' : schema?.title || schema.name
  const schemaHash = apiType === API_TYPE.ASYNCAPI ? `#/schema-${encodeURIComponent(schemaIdentifier)}` : `#/${encodeURIComponent(schemaIdentifier)}`

  useEffect(() => {
    if (active && schemaHash === locationHash) {
      setSelectedSchema(schemaIdentifier)
    } else if (!active) {
      setSelectedSchema(null)
    }
  }, [active, schemaHash, locationHash, setSelectedSchema, schema.name])
  
  const navActiveItemRef = useScrollIntoView<HTMLAnchorElement>()

  const { closeSideNavWithoutTransition } = useOutletContext<RootOutletContext>()
  
  const onNavigate = (e) => {
    onClick?.(e)
    closeSideNavWithoutTransition?.()
  }

  return (
    <Link to={`${parentPath}${schemaHash}`}
      onClick={onNavigate}
      className={clsx(
        'ml-1 flex py-1.5 pl-2 pr-8 rounded max-w-full overflow-hidden z-40',
        active && 'hover:bg-neutral-20 dark:hover:bg-neutral-90',
        isSelected ? 'bg-neutral-20 dark:bg-neutral-90 text-consumer-blue dark:text-dark-consumer-blue font-semibold' : '',
      )} ref={(active && schemaHash === locationHash) ? navActiveItemRef : null}>
      <span className={clsx('pl-1 pr-2 pt-[0.219rem]', isSelected ? 'text-neutral-60 dark:text-neutral-40' : 'text-neutral-50 dark:text-neutral-40')}>
        {active && schemaHash === locationHash ? <IconCubeSolid /> : <IconCube />}
      </span>
      <div className="overflow-hidden break-words">
        {schemaIdentifier}
      </div>
    </Link>
  )
}